export default "__VITE_ASSET__BngoFmT5__"